import React, { useState } from 'react'
import { Folder, FolderOpenOutlined } from '@mui/icons-material'
import { useSelector } from 'react-redux'
import { TenantEditSlice } from '../../../../reducers'
import { FileUploader } from '@emerald-works-nova/components'

const MAX_SIZE = 2

const Label = () => (
  <>
    Drop <strong>CSV file</strong> here to upload or{' '}
  </>
)

const Description = ({ file, tenant }) => {
  if (file) {
    return (
      <span>
        All users in this file will be added to the{' '}
        <strong>{tenant.name}</strong> Toolkit
      </span>
    )
  }
  return `Max file size ${MAX_SIZE} MB`
}

const UploadInput = ({ onAccept, onValidation = () => {} }) => {
  const tenant = useSelector(TenantEditSlice.selectors.tenant)

  const [file, setFile] = useState()

  const handleDropAccepted = file => {
    setFile(file)
    onAccept(file)
  }

  return (
    <FileUploader
      label={file ? file.name : <Label />}
      maxSize={MAX_SIZE * 1024 * 1024}
      description={<Description file={file} tenant={tenant} />}
      Icon={file ? Folder : FolderOpenOutlined}
      accept='.csv'
      fileNamePrefix={`bulk-user-upload/${tenant.pk}/`}
      onDropAccepted={handleDropAccepted}
      articleBodyUploader
      validator={onValidation}
      storageOpts={{
        level: 'private'
      }}
      dataTest='csv-file-uploader'
    />
  )
}

export default UploadInput
